/**
 * index.tsx
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { FC }          from 'react';
import { useField }    from 'formik';
import { Label }       from '~/components/label';
import { NumberProps }  from './types';
import { styles }      from './styles';

export const NumberInput: FC<NumberProps> = ({ name, step = 1, label, description, ...props }) => {
  const [field, meta] = useField({ ...props, name, type: 'text' });
  const handlePrevClick = () => {
    const value = Number.parseFloat(field.value) || 1;
    field.onChange({ target: {
      name: field.name,
      value: Math.max(1, value - step) }
    });
  }
  const handleNextClick = () => {
    const value = Number.parseFloat(field.value) || 1;
    field.onChange({ target: {
      name: field.name,
      value: Math.min(10, value + step) }
    });
  }

  return (
    <div css={styles.container}>
      {label && <Label info={description}>{label}</Label>}

      <div css={styles.wrapper}>
        <button css={styles.button} onClick={handlePrevClick} type="button">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false">
            <path fillRule="evenodd" clipRule="evenodd" d="M20 12.5H4v-1h16z" fill="currentColor" />
          </svg>
        </button>
        <input
          {...field}
          {...props}
          css={styles.input}
          disabled
        />
        <button css={styles.button} onClick={handleNextClick} type="button">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false">
            <path d="M12.5 11.5V4h-1v7.5H4v1h7.5V20h1v-7.5H20v-1z" fill="currentColor" />
          </svg>
        </button>
      </div>
    </div>
  );
};
